/**
 * Persona chat image limits for Bedrock vision calls.
 * Mirrors SurveyApi `ImageProcesor` (≤1080px longest edge, JPEG output).
 */
export const PERSONA_CHAT_IMAGE_MAX_DIMENSION_PX = 1080;

/** JPEG quality for client-side encoding before Bedrock vision calls. */
export const PERSONA_CHAT_IMAGE_JPEG_QUALITY = 0.85;

export const PERSONA_CHAT_IMAGE_OUTPUT_MIME_TYPE = 'image/jpeg';
